// context/EditIdContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";

const EditIdContext = createContext();

export const EditIdProvider = ({ children }) => {
  const [editId, setEditId] = useState(() => {
    const stored = localStorage.getItem("editId");
    return stored && stored !== "null" ? stored : null;
  });
  useEffect(() => {
    if (editId ) {
      localStorage.setItem("editId", editId);
    } 
  }, [editId]);

  return (
    <EditIdContext.Provider value={{ editId, setEditId }}>
      {children}
    </EditIdContext.Provider>
  );
};

export const useEditId = () => useContext(EditIdContext);
